import http from "infra/http";
import { useMutation } from "react-query";
import { InstrucaoBoletoResponse } from "../typings";

function useSaveInstrucaoBoleto(tenantId: string) {
  return useMutation(
    [`/v1/instrucao-boleto`],
    async (items: InstrucaoBoletoResponse[]) => {
      return http.post(
        `/v1/instrucao-boleto`,
        {
          items,
        },
        {
          headers: {
            tenant: tenantId,
          },
        }
      );
    }
  );
}

export default useSaveInstrucaoBoleto;
